module.exports = __webpack_public_path__ + "fonts/Gilroy-BlackItalic.fba7a117.ttf";